var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.666687 11.0614C0.666687 16.5303 4.6386 21.0778 9.83335 22V14.0553H7.08335V11H9.83335V8.55525C9.83335 5.80525 11.6053 4.27808 14.1114 4.27808C14.9053 4.27808 15.7614 4.4 16.5553 4.52192V7.33333H15.15C13.8053 7.33333 13.5 8.00525 13.5 8.86142V11H16.4334L15.9448 14.0553H13.5V22C18.6948 21.0778 22.6667 16.5312 22.6667 11.0614C22.6667 4.9775 17.7167 0 11.6667 0C5.61669 0 0.666687 4.9775 0.666687 11.0614Z",
    fill: "#737373"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.efd5bbb0ad2caaf0aee20f8d130e5d0f.svg";
export { ForwardRef as ReactComponent };